var map = {
	"./bnb/ada.png": 143,
	"./bnb/atom.png": 144,
	"./bnb/avax.png": 145,
	"./bnb/bnb.png": 146,
	"./bnb/btc.png": 147,
	"./bnb/btt.png": 148,
	"./bnb/doge.png": 149,
	"./bnb/dot.png": 150,
	"./bnb/eos.png": 151,
	"./bnb/fil.png": 152,
	"./bnb/iota.png": 153,
	"./default/bat.png": 154,
	"./default/btc.png": 155,
	"./default/busd.png": 156,
	"./default/dgb.png": 157,
	"./default/eth.png": 158,
	"./default/kmd.png": 159,
	"./default/mcl.png": 160,
	"./default/qtum.png": 161,
	"./default/rvn.png": 162,
	"./default/usdc.png": 163,
	"./default/vrsc.png": 164,
	"./eth/bat.png": 165,
	"./eth/busd.png": 166,
	"./eth/dai.png": 167,
	"./eth/eth.png": 168,
	"./eth/kcs.png": 169,
	"./eth/link.png": 170,
	"./eth/paxos.png": 171,
	"./eth/tusd.png": 172,
	"./eth/uni.png": 173,
	"./eth/usdc.png": 174,
	"./eth/yfi.png": 175,
	"./kmd_1.png": 176,
	"./kmd_2.png": 177,
	"./qtum/hlc.png": 178,
	"./qtum/hpy.png": 179,
	"./qtum/ink.png": 180,
	"./qtum/lstr.png": 181,
	"./qtum/med.png": 182,
	"./qtum/oc.png": 183,
	"./qtum/put.png": 184,
	"./qtum/qbt.png": 185,
	"./qtum/qc.png": 186,
	"./qtum/qi.png": 187,
	"./qtum/qtum.png": 188,
	"./qtum/spc.png": 189,
	"./qtum/tsl.png": 190,
	"./qtum/zat.png": 191,
	"./utxo/bch.png": 192,
	"./utxo/btc.png": 193,
	"./utxo/dash.png": 194,
	"./utxo/dgb.png": 195,
	"./utxo/doge.png": 196,
	"./utxo/emc2.png": 197,
	"./utxo/firo.png": 198,
	"./utxo/ltc.png": 199,
	"./utxo/nav.png": 200,
	"./utxo/rvn.png": 201,
	"./utxo/vrsc.png": 202
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 142;